import i18n from 'i18next';

function getLocale() {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const locale = params.get('l');
  const validLocales = i18n.languages;
  if (locale && validLocales && validLocales.includes(locale)) {
    return locale;
  }
  return 'en';
}

export default getLocale;
